<template>
  <tag-item
    v-if="gradeLevel"
    v-b-tooltip.hover
    :title="$t('rubrics.studentLevel')"
    :label="$t(gradeLevel.translationKey)"
    :size="size"
    class="eg-grading-details-level"
    :class="{ 'is-rubric-card': isRubricCard }"
    :style="isRubricCard ? { color: gradeLevel?.color } : {}"
  >
    <div
      class="eg-grading-details-icon-container"
      :style="{
        color: gradeLevel?.color,
      }"
    >
      <eg-b-icon :icon="gradeLevel?.icon" />
    </div>
  </tag-item>
</template>

<script>
import { GRADE_LEVELS } from "@/constants";
import TagItem from "@/components/folders/tag-item.vue";

export default {
  name: "EgGradingDetailsLevel",

  components: {
    TagItem,
  },

  props: {
    gradingDetailsLevel: {
      type: String,
      required: true,
      validator: (value) =>
        ["elementary", "middleschool", "highschool", "college"].includes(value),
    },

    size: {
      type: String,
      default: "medium",
      validator: (value) => ["small", "medium", "large"].includes(value),
    },

    isRubricCard: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    gradeLevel() {
      return GRADE_LEVELS.find(
        (option) => option.value === this.gradingDetailsLevel
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.eg-grading-details-level {
  // Override default tag-item styles
  color: var(--color-tag-text);
  border-radius: var(--radius-rd-500);
  line-height: normal;

  &.is-rubric-card {
    // When used in rubric card, text color matches icon color
    ::v-deep .tag-title {
      color: inherit;
    }
  }

  // Override large size to have custom dimensions
  &::v-deep.eg-tag-size--large {
    height: 26px;
    padding: 4px 8px;
    font-size: var(--typography-font-size-fs-200);
  }
}

.eg-grading-details-icon-container {
  display: flex;
  width: 16px;
  height: 16px;
  align-items: center;
  justify-content: center;
  font-size: 9.33px;
}
</style>
